import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import WhoAmI from "./Components/WhoAmI"
import { withStyles } from "@material-ui/core"
import Identary from "./Components/Identary";
import Video from './Components/Video'

const style = {
    root: {
        width: '100vw',
    }
}

class App extends Component {
    render() {
        // const { classes } = this.props
        return (
            <Switch>
                <Route exact path='/' component={() => {
                    window.location.replace('http://idamon.jp')
                    return null
                }}/>
                <Route exact path={'/whoami'} component={WhoAmI}/>
                <Route path={'/whoami/:id'} component={Video}/>
                <Route exact path={'/identary'} component={Identary}/>
            </Switch>
        );
    }
}

export default withStyles(style)(App)
